/**
 * Issues de Zod que rechazaron un payload.
 *
 * Es la razon de existir de la cuarentena: en vez de "payload invalido", se
 * muestra que campo fallo, que se esperaba y que llego. Si la columna jsonb trae
 * algo que no se puede interpretar, se cae al JSON crudo en vez de mentir
 * diciendo que no hubo issues.
 */
import type { ReactElement } from 'react';
import { normalizeZodIssues } from '../lib/quarantine-issues';
import { JsonPanel } from './JsonPanel';

export function QuarantineIssues({ zodIssues }: { readonly zodIssues: unknown }): ReactElement {
  const issues = normalizeZodIssues(zodIssues);

  if (issues.length === 0) {
    return (
      <JsonPanel
        title="Issues de validación (formato no reconocido)"
        value={zodIssues}
        emptyLabel="La cuarentena no registró issues de validación."
      />
    );
  }

  return (
    <ul className="issues">
      {issues.map((issue, index) => (
        <li className="issue" key={`${issue.path}-${issue.code}-${index}`}>
          <span className="issue__path">{issue.path}</span>
          <p className="issue__message">{issue.message}</p>
          <div className="issue__meta">
            código: {issue.code}
            {issue.expected === null ? '' : ` · esperado: ${issue.expected}`}
            {issue.received === null ? '' : ` · recibido: ${issue.received}`}
          </div>
        </li>
      ))}
    </ul>
  );
}
